module.exports = __webpack_public_path__ + "static/telephone-illustration-19337d528ab4ef2627d2f1306989e9cc.png";